import { defineSagaForService } from '@repo/core'
import { patchUserInfo, patchUserPreferences } from '@repo/user-services'
import { editUserInfoActions, editUserPreferencesActions } from '../../slices'

export const preferencesMutationsServiceConfig = defineSagaForService({
  [editUserPreferencesActions.patchRequest.type]: {
    apiClientDomain: 'user',
    service: patchUserPreferences,
    actionTypeResponse: editUserPreferencesActions.patchResponse.type,
    actionTypeRequest: editUserPreferencesActions.patchRequest.type,
  },
  [editUserInfoActions.patchRequest.type]: {
    apiClientDomain: 'user',
    service: patchUserInfo,
    actionTypeResponse: editUserInfoActions.patchResponse.type,
    actionTypeRequest: editUserInfoActions.patchRequest.type,
  },
})
